<ng-container *ngIf="stepIndicatorViewModel">
    <tm-step-indicator
        (selectedChange)="onSelectedStepChange($event)"
        (beforeStepChange)="
            onBeforeStepChange($event.cb, $event.arg, $event.isBack)
        "
        [compact]="isCompact"
        [selected]="selectedStepId"
        class="tm-property-tabs__step-indicator"
    >
        <ng-container
            *ngFor="
                let step of stepIndicatorViewModel.steps;
                let isLast = last;
                trackBy: trackByFn
            "
        >
            <tm-step-indicator-item
                *ngIf="step.isVisible"
                [disabled]="step.isDisabled"
                [id]="step.stepId"
                [title]="step.title"
            >
                <ng-container *tmStepIndicatorIcon>
                    <tg-icon
                        *ngIf="step.isCheckmarkVisible"
                        name="basic-tick-framed"
                        role="presentation"
                    >
                    </tg-icon>
                    <tg-icon
                        *ngIf="step.isCrossVisible"
                        name="stop"
                        role="presentation"
                        tgStyle="danger"
                    >
                    </tg-icon>
                    <tg-icon
                        *ngIf="
                            !isCompact &&
                            !isLast &&
                            !step.isCheckmarkVisible &&
                            !step.isCrossVisible &&
                            stepIndicatorViewModel.selectedStepId !==
                                step.stepId
                        "
                        name="basic-arrow-right"
                        role="presentation"
                        size="small"
                    >
                    </tg-icon>
                </ng-container>
            </tm-step-indicator-item>
        </ng-container>
    </tm-step-indicator>
</ng-container>
